<template>
  <div class="text-xs text-gray-500" v-if="saving">Saving…</div>
  <div class="text-xs text-gray-500" v-else>
    Last saved: 
    <span v-if="lastSaved">{{ new Date(lastSaved).toLocaleString() }}</span>
    <span v-else>Never</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ saving: boolean; lastSaved: number | null }>();
</script>